import posthog from "posthog-js";

const SESSION_DURATION = 30 * 60 * 1000; // 30 minutes

export const PH_EVENTS = {
  SIGN_UP: {
    START: "Signup: step 1 shown",
    COMPLETE: "Signup: step 1 completed",
    CONFIRM: "Signup: email confirmed",
    START_PP_PAYMENT: "Signup: started PP payment",
  },
  SITE: {
    SESSION_START: "Site: session start",
    VISITED_SEARCH_PAGE: "Site: visited search page",
    VISITED_DIRECTORY_PAGE: "Site: visited directory page",
    VISITED_RRP: "Site: visited RRP",
    GO_TO_RESOURCE: "Site: go to resource",
    SIGNED_IN: "Site: signed in",
    SAW_AB_EXPERIMENT: "Site: saw AB experiment",
    LOADED_BOCLIPS_VIDEO: "Site: loaded Boclips Video",
    PLAYED_BOCLIPS_VIDEO: "Site: played Boclips Video",
  },
  VISITOR: {
    SELECTED_ONE_TOOL: "Visitor: selected one AI tool",
    SELECTED_TOOL_LIST: "Visitor: selected AI Tools list",
    SELECTED_SEARCH_VIDEOS: "Visitor: selected search videos",
    SELECTED_SEARCH_RESOURCES: "Visitor: selected search resources",
  },
};

export function user_identify(distinct_id, user_properties) {
  posthog.identify(distinct_id, user_properties);
  posthog.capture(PH_EVENTS.SITE.SIGNED_IN);
}

export function user_reset() {
  posthog.reset();
}

export function user_group(type, group_id, data) {
  posthog.group(type, group_id, data);
}

export function user_session() {
  const sessionTimestamp = parseInt(localStorage.getItem("session-timestamp") || 0, 10);
  const currentTimestamp = Date.now();
  const sessionInterval = currentTimestamp - sessionTimestamp;

  if (!sessionTimestamp || sessionInterval > SESSION_DURATION) {
    posthog.capture(PH_EVENTS.SITE.SESSION_START);
  }
  localStorage.setItem("session-timestamp", currentTimestamp);
}

export function track_experiment(experimentName, variationName) {
  posthog.capture(PH_EVENTS.SITE.SAW_AB_EXPERIMENT, { experiment_name: experimentName, variation: variationName });
}
